<template>
  <div v-if="element" style="height: 100%">
    <!-- <v-form ref="form" v-model="valid" lazy-validation autocomplete="off"> -->
    <v-text-field
      :key="element.column + element.id"
      autocomplete="off"
      pt-0
      pb-0
      v-if="element.type == 'input' || element.type == 'number'"
      :label="element.label"
      v-model="element.model"
      :value="element.model"
      :rules="element.required ? notEmpty : []"
      :name="element.column ? element.column : element.id"
      :error-messages="
        errors.collect(element.column ? element.column : element.id)
      "
      :placeholder="element.placeholder ? element.placeholder : ' '"
      :hint="element.hint ? element.hint : ''"
      append-outer-icon=""
      :mask="element.mask ? element.mask : ''"
      :outline="element.designType == 'outline' ? true : false"
      :solo="element.designType == 'solo' ? true : false"
      :solo-inverted="element.designType == 'solo-inverted' ? true : false"
      :tabindex="element.tabIndex"
    ></v-text-field>
    <v-text-field
      :key="element.column + element.id"
      autocomplete="off"
      pt-0
      pb-0
      v-if="element.type == 'date'"
      :label="element.label"
      v-model="element.model"
      :rules="element.required ? notEmpty : []"
      :name="element.column ? element.column : element.id"
      :error-messages="
        errors.collect(element.column ? element.column : element.id)
      "
      :placeholder="element.placeholder ? element.placeholder : ' '"
      :hint="element.hint ? element.hint : ''"
      append-outer-icon=""
      :mask="element.mask ? element.mask : ''"
      :outline="element.designType == 'outline' ? true : false"
      :solo="element.designType == 'solo' ? true : false"
      :solo-inverted="element.designType == 'solo-inverted' ? true : false"
      :tabindex="element.tabIndex"
    ></v-text-field>
    <v-text-field
      :key="element.column + element.id"
      autocomplete="off"
      pt-0
      pb-0
      v-if="element.type == 'time'"
      :label="element.label"
      v-model="element.model"
      :rules="element.required ? notEmpty : []"
      :name="element.column ? element.column : element.id"
      :error-messages="
        errors.collect(element.column ? element.column : element.id)
      "
      :placeholder="element.placeholder ? element.placeholder : ' '"
      :hint="element.hint ? element.hint : ''"
      append-outer-icon=""
      :mask="element.mask ? element.mask : ''"
      :outline="element.designType == 'outline' ? true : false"
      :solo="element.designType == 'solo' ? true : false"
      :solo-inverted="element.designType == 'solo-inverted' ? true : false"
      :tabindex="element.tabIndex"
    ></v-text-field>
     <v-text-field
      :key="element.column + element.id"
      autocomplete="off"
      pt-0
      pb-0
      v-if="element.type == 'file'"
      :label="element.label"
      v-model="element.model"
      :rules="element.required ? notEmpty : []"
      :name="element.column ? element.column : element.id"
      :error-messages="
        errors.collect(element.column ? element.column : element.id)
      "
      :placeholder="element.placeholder ? element.placeholder : ' '"
      :hint="element.hint ? element.hint : ''"
      append-outer-icon="attach_file"
      :mask="element.mask ? element.mask : ''"
      @click:append-outer="loadFileDialog()"
      :outline="element.designType == 'outline' ? true : false"
      :solo="element.designType == 'solo' ? true : false"
      :solo-inverted="element.designType == 'solo-inverted' ? true : false"
      :tabindex="element.tabIndex"
    ></v-text-field>

    <!-- <div v-if="element.type == 'file'">
      <v-card
        flat
        tile
        class="d-flex"
        v-if="element.model && checkUrl(element.model)"
      >
        <v-img :src="element.model" aspect-ratio="1" class="grey lighten-2">
          <template v-slot:placeholder>
            <v-layout fill-height align-center justify-center ma-0>
              <v-progress-circular
                indeterminate
                color="grey lighten-5"
              ></v-progress-circular>
            </v-layout>
          </template>
        </v-img>
      </v-card>
      <v-card
        flat
        tile
        class="d-flex"
        v-if="element.model && !checkUrl(element.model)"
      >
        <v-img :src="element.model" aspect-ratio="1" class="grey lighten-2">
          <template v-slot:placeholder>
            <v-layout fill-height align-center justify-center ma-0>
              <v-progress-circular
                indeterminate
                color="grey lighten-5"
              ></v-progress-circular>
            </v-layout>
          </template>
        </v-img>
      </v-card>
    </div> -->
    <v-text-field
      v-if="element.type == 'password'"
      autocomplete="new-password"
      v-model="element.model"
      :append-icon="element.show ? 'visibility' : 'visibility_off'"
      append-outer-icon="refresh"
      :rules="element.required ? passwordRule : []"
      :type="element.show ? 'text' : 'password'"
      :name="element.column ? element.column : 'password_' + index"
      :error-messages="
        errors.collect(element.column ? element.column : 'password_' + index)
      "
      :label="element.label"
      :placeholder="element.placeholder ? element.placeholder : ' '"
      :hint="element.hint ? element.hint : ''"
      counter
      @click:append="element.show = !element.show"
      @click:append-outer="element.show = true; element.model = element.generatePassword()"
      :outline="element.designType == 'outline' ? true : false"
      :solo="element.designType == 'solo' ? true : false"
      :solo-inverted="element.designType == 'solo-inverted' ? true : false"
      :tabindex="element.tabIndex"
    ></v-text-field>
    <v-textarea
      pt-0
      pb-0
      :rules="element.required ? notEmpty : []"
      v-if="element.type == 'textarea'"
      :label="element.label"
      v-model="element.model"
      :placeholder="element.placeholder ? element.placeholder : ' '"
      :hint="element.hint ? element.hint : ''"
      :outline="element.designType == 'outline' ? true : false"
      :solo="element.designType == 'solo' ? true : false"
      :solo-inverted="element.designType == 'solo-inverted' ? true : false"
      :tabindex="element.tabIndex"
    ></v-textarea>
    <v-textarea
      pt-0
      pb-0
      :rules="element.required ? notEmpty : []"
      v-if="element.type == 'html'"
      :label="element.label"
      v-model="element.model"
      :placeholder="element.model ? element.model : ' '"
      :outline="element.designType == 'outline' ? true : false"
      :solo="element.designType == 'solo' ? true : false"
      :solo-inverted="element.designType == 'solo-inverted' ? true : false"
      :tabindex="element.tabIndex"
    ></v-textarea>
    <v-checkbox
      pt-0
      pb-0
      v-if="element.type == 'checkbox'"
      :label="element.label"
      v-model="element.model"
      :tabindex="element.tabIndex"
    ></v-checkbox>
    <v-select
      pt-0
      pb-0x
      v-if="element.type == 'select' && element.multiple === true"
      v-model="element.models"
      :item-text="element.itemText ? element.itemText : 'text'"
      :item-value="element.itemValue ? element.itemValue : 'value'"
      :multiple="element.multiple"
      :items="element.items"
      :label="element.label"
      :hint="element.hint ? element.hint : ''"
      :persistent-hint="true"
      :return-object="false"
      chips
      :outline="element.designType == 'outline' ? true : false"
      :solo="element.designType == 'solo' ? true : false"
      :solo-inverted="element.designType == 'solo-inverted' ? true : false"
      :tabindex="element.tabIndex"
    ></v-select>
    <v-select
      pt-0
      pb-0x
      v-if="element.type == 'select' && element.multiple !== true"
      v-model="element.model"
      :item-text="element.itemText ? element.itemText : 'text'"
      :item-value="element.itemValue ? element.itemValue : 'value'"
      :multiple="element.multiple"
      :items="element.items"
      :label="element.label"
      :hint="element.hint ? element.hint : ''"
      :persistent-hint="true"
      :return-object="false"
      chips
      :outline="element.designType == 'outline' ? true : false"
      :solo="element.designType == 'solo' ? true : false"
      :solo-inverted="element.designType == 'solo-inverted' ? true : false"
      :tabindex="element.tabIndex"
    ></v-select>
    <v-combobox
      pt-0
      pb-0x
      v-if="element.type == 'combobox'"
      v-model="element.models"
      item-text="text"
      item-value="value"
      :items="element.items"
      :label="element.label"
      :hint="element.hint ? element.hint : ''"
      :persistent-hint="true"
      :return-object="false"
      multiple
      chips
      :outline="element.designType == 'outline' ? true : false"
      :solo="element.designType == 'solo' ? true : false"
      :solo-inverted="element.designType == 'solo-inverted' ? true : false"
      :tabindex="element.tabIndex"
    ></v-combobox>
    <v-switch
      v-if="element.type == 'switch'"
      v-model="element.model"
      :label="element.label"
      :persistent-hint="true"
      :hint="element.hint ? element.hint : ''"
      :tabindex="element.tabIndex"
    ></v-switch>
    <v-btn
      v-if="element.type == 'button'"
      dark
      :loading="element.loading ? element.loading : false"
      :class="element.className ? element.className : ''"
      :style="element.style ? 'margin: 0px 0px;' + element.style : 'margin: 0px 0px;'"
      :color="element.color ? element.color : ''"
      v-on:click="btnClicked(element)"
      :tabindex="element.tabIndex"
      >{{ element.label }}</v-btn
    >
    <editor-element
      v-if="element.type == 'editor-element'"
      :element="element"
      :mention="element"
      :tabindex="element.tabIndex"
    ></editor-element>
    <!-- </v-form> -->

    <v-dialog v-model="fileDialog" width="80%" v-if="element.type == 'file'">
      <v-card>
        <v-card-text style="min-height: 650px">
          <dms :element="element" :mode="'select'" :events="events" :description="'Select File'" :namespace="element.namespace" v-if="element.namespace && fileDialog && typeof element.selectFile != 'undefined'" />
          <span v-if="!element.namespace">Namespace Value Required</span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat="flat" @click="fileDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import EditorElement from "./editor-element.vue";
const DMS = () => import('@/components/charts/dms/chart.vue');

export default {
  props: ["chart", "element", "item", "index", "display"],
  data: function () {
    const that = this;
    return {
      fileDialog: false,
      valid: true,
      events: {
        selectFile: function(file) {
          that.element.model = file.url;
          that.fileDialog = false;
        }
      },
      notEmpty: [
        (v) => !!v || "Field is required ",
        (v) => (v && String(v).length > 0) || "Field is required ",
      ],
      passwordRule: [
        (v) => !!v || "Field is required",
        (v) => (v && v.length > 6) || "Value must be longer than 6 characters",
      ],
    };
  },
  components: {
    "editor-element": EditorElement,
    "dms": DMS
  },
  methods: {
    btnClicked(triggerElement) {
      if (this.display == "view") {
        this.chart.send(triggerElement);
      }
    },
    checkURL(url) {
      return url.match(/\.(jpeg|jpg|gif|png)$/) != null;
    },
    loadFileDialog(element) {
      if (this.display == "view") {
        this.fileDialog = true;
      }
      
    }
  },
  beforeMount() {
    // const that = this;
    // if(this.element) {
    //   // alert("here");
    //   console.log("this.element.type", this.element.type);
    //   this.element.selectFile = function(file) {
    //     that.element.model = file.url;
    //     that.fileDialog = false;
    //   }
    //   console.log("this.element.selectFile", this.element.selectFile);
    // }
  },
  computed: {},
  mounted: function () {
    
  },
  beforeDestroy() {},
};
</script>     